import { supabase } from "../supabase";

export async function getArticleImages(articleId) {
    const res = await supabase
        .from('article_image')
        .select()
        .eq('article_id', articleId)
        .order('ordinal', { ascending: true });
    if (res.status !== 200) {
        throw Error('Failed to fetch article image');
    }

    return res.data ?? [];
}
